const localization = {
  en: {
    document: 'DOCUMENT TYPE',
    radiology: 'Radiology',
    microbiology: 'Microbiology',
    dates: 'Date',
    download: 'download',
    documentType: 'Document Type',
    verifyingProvider: 'Verifying Provider',
    errorTitle: 'Something went wrong',
    downloadNotFound: 'Document not found.',
    downloadAttachmentError: 'Could not load the document. Please try again.',
    downloadErrorUnauthorized:
      "You don't have permission to access this document.",
    downloadErrorTimeout:
      'The document took too long to load. Please try again.',
    downloadErrorGateway:
      'The service is temporarily unavailable. Please try again later.',
    downloadErrorCorrupted:
      "This document appears to be corrupted and can't be opened."
  },
  es: {
    document: 'TIPO DE DOCUMENTO',
    radiology: 'Radiología',
    microbiology: 'Microbiología',
    dates: 'Fecha',
    download: 'Descargar',
    documentType: 'Tipo de documento',
    verifyingProvider: 'Verificador del médico',
    errorTitle: 'Ha ocurrido un error',
    downloadNotFound: 'Documento no encontrado.',
    downloadAttachmentError:
      'No se pudo descargar el documento adjunto. Por favor, inténtelo de nuevo.',
    downloadErrorUnauthorized:
      'No tiene permiso para acceder a este documento.',
    downloadErrorTimeout:
      'El documento tardó demasiado en cargar. Por favor, inténtelo de nuevo.',
    downloadErrorGateway:
      'El servicio no está disponible temporalmente. Por favor, inténtelo más tarde.',
    downloadErrorCorrupted:
      'Este documento parece estar dañado y no se puede abrir.'
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    document: 'UFD_Documents_Text',
    radiology: 'UFD_Radiology_Text',
    microbiology: 'UFD_Microbiology_Text',
    dates: 'UFD_Date_Text',
    download: 'UFD_Download_Button',
    documentType: 'UFD_Document_Type_Text',
    verifyingProvider: 'UFD_Verifying_Provider_Text'
  }
  /* eslint-disable no-secrets/no-secrets */
}

export default localization
